import { render, staticRenderFns } from "./contact_details.vue?vue&type=template&id=f50463a2&scoped=true"
import script from "./contact_details.vue?vue&type=script&lang=js"
export * from "./contact_details.vue?vue&type=script&lang=js"
import style0 from "./contact_details.vue?vue&type=style&index=0&id=f50463a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f50463a2",
  null
  
)

export default component.exports